import { render, staticRenderFns } from "./new-employee.vue?vue&type=template&id=034d0431"
import script from "./new-employee.vue?vue&type=script&lang=js"
export * from "./new-employee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports